var React = require('react');

function IconPlusInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 .5c.518 0 .938.42.938.938l-.001 5.624h5.626a.937.937 0 1 1 0 1.875H8.936v5.626a.937.937 0 1 1-1.874 0l-.001-5.626H1.437a.937.937 0 1 1 0-1.874l5.625-.001V1.437C7.063.92 7.482.5 8 .5z","fill":"#000","fillRule":"evenodd"}));
}

IconPlusInline.defaultProps = {"width":"16","height":"16"};

module.exports = IconPlusInline;

IconPlusInline.default = IconPlusInline;
